// Import the functions you need
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
} from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAjK98MkxOHFL4cETnlemWV9kjhmmQnvCM",
  authDomain: "delivery-cook.firebaseapp.com",
  projectId: "delivery-cook",
  storageBucket: "delivery-cook.firebasestorage.app",
  messagingSenderId: "187274199577",
  appId: "1:187274199577:web:d07488bfeb466ecf9e6088",
};

// Firebase 앱 초기화
const app = initializeApp(firebaseConfig);

// Messaging 조건부 초기화
let messaging = null;
let messagingSupported = false;
let initializationPromise = null;

// 브라우저 지원 여부 확인 후 초기화
const initializeMessaging = async () => {
  try {
    // Service Worker와 Notification API 지원 여부 확인
    if (
      typeof window !== "undefined" &&
      "serviceWorker" in navigator &&
      "Notification" in window &&
      "PushManager" in window
    ) {
      const supported = await isSupported();
      if (supported) {
        messaging = getMessaging(app);
        messagingSupported = true;
        console.log("Firebase Messaging 초기화 완료");
      } else {
        console.warn("Firebase Messaging이 이 브라우저에서 지원되지 않습니다.");
      }
    } else {
      console.warn("Service Worker 또는 Notification API가 지원되지 않습니다.");
    }
  } catch (error) {
    console.warn("Firebase Messaging 초기화 실패:", error);
    messaging = null;
    messagingSupported = false;
  }
};

// 초기화를 Promise로 래핑하여 여러 번 호출되지 않도록 보장
const getInitializationPromise = () => {
  if (!initializationPromise) {
    initializationPromise = initializeMessaging();
  }
  return initializationPromise;
};

// 페이지 로드 시 초기화 시작
if (typeof window !== "undefined") {
  getInitializationPromise();
}

// 안전한 messaging export
export { messaging, messagingSupported, getInitializationPromise };

// 브라우저에서 알림 권한 요청 + FCM 토큰 가져오기
export const requestPermission = async () => {
  if (!messagingSupported || !messaging) {
    console.log("Firebase Messaging이 지원되지 않는 환경입니다.");
    return null;
  }

  try {
    console.log("🔔 알림 권한 요청 시작...");
    
    // 현재 권한 상태 확인
    const currentPermission = Notification.permission;
    console.log("📋 현재 알림 권한 상태:", currentPermission);
    
    // PWA 환경 감지
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true ||
                  document.referrer.includes('android-app://');
    
    console.log("📱 PWA 환경 감지:", isPWA);
    
    let permission;
    
    if (currentPermission === "default") {
      console.log("🤔 권한 요청 필요, 사용자 액션으로 요청 중...");
      
      // PWA에서 팝업이 먹통일 때를 위한 안전한 권한 요청
      if (isPWA) {
        console.log("🔧 PWA 환경: 안전한 권한 요청 방법 적용");
        
        try {
          // PWA에서 더 안전한 Promise 기반 처리
          permission = await new Promise((resolve, reject) => {
            // 10초 타임아웃 (PWA에서 더 길게)
            const timeout = setTimeout(() => {
              console.log("⏰ PWA 권한 요청 타임아웃 (10초)");
              resolve("timeout");
            }, 10000);
            
            // 권한 요청 시도
            Notification.requestPermission()
              .then((result) => {
                clearTimeout(timeout);
                console.log("✅ PWA 권한 요청 완료:", result);
                resolve(result);
              })
              .catch((error) => {
                clearTimeout(timeout);
                console.warn("⚠️ PWA 권한 요청 에러:", error);
                
                // 에러 발생 시 현재 상태 다시 확인
                const currentState = Notification.permission;
                console.log("🔄 에러 후 현재 상태:", currentState);
                resolve(currentState === "granted" ? "granted" : "denied");
              });
          });
          
          // 타임아웃된 경우 현재 상태 다시 확인
          if (permission === "timeout") {
            console.log("🔄 타임아웃 후 현재 권한 상태 재확인");
            permission = Notification.permission;
            console.log("📋 재확인 결과:", permission);
            
            // 여전히 default라면 대체 방법 시도
            if (permission === "default" && 'permissions' in navigator) {
              try {
                const result = await navigator.permissions.query({ name: 'notifications' });
                permission = result.state === 'granted' ? 'granted' : 
                           result.state === 'denied' ? 'denied' : 'default';
                console.log("📱 navigator.permissions 대체 결과:", permission);
              } catch (permError) {
                console.warn("⚠️ navigator.permissions 실패:", permError);
              }
            }
          }
          
        } catch (error) {
          console.warn("⚠️ PWA 권한 요청 실패:", error);
          permission = Notification.permission; // 현재 상태로 폴백
        }
      } else {
        // 일반 브라우저에서는 표준 방법 사용
        console.log("💻 일반 브라우저: 표준 권한 요청");
        try {
          permission = await Notification.requestPermission();
          console.log("✅ 표준 권한 요청 결과:", permission);
        } catch (error) {
          console.warn("⚠️ 표준 권한 요청 실패:", error);
          permission = "denied";
        }
      }
    } else {
      permission = currentPermission;
      console.log("📋 기존 권한 사용:", permission);
    }
    
    if (permission === "granted") {
      console.log("🎉 알림 권한 승인됨, FCM 토큰 발급 중...");
      
      try {
        const token = await getToken(messaging, {
          vapidKey: "BL0KAQqBFcsc1mgPqUOsEtZJY0Qvmekq4aRIJb5OaZEkZWKTX10yODGYdYpN5BoMoCz0n2GoD01y4CTtdmwveuI",
        });
        
        if (token) {
          console.log("🔑 FCM Token 발급 성공:", token.substring(0, 20) + "...");
          return token;
        } else {
          console.warn("⚠️ FCM Token 발급 실패");
          return null;
        }
      } catch (tokenError) {
        console.error("❌ FCM Token 발급 중 오류:", tokenError);
        return null;
      }
    } else if (permission === "denied") {
      console.log("❌ 알림 권한 거부됨");
      return null;
    } else {
      console.log("⏳ 알림 권한 대기 중 (사용자가 아직 결정하지 않음)");
      return null;
    }
  } catch (error) {
    console.error("💥 권한 요청 중 치명적 오류:", error);
    return null;
  }
};
